import { bronLabel } from './prospect';
// Contractuele uitzonderingen op de Reseller Fee %.
//
// Normaal komt dat percentage uit de gebruiker (users.reseller_fee_pct, default
// 75%): per verkoopteam via de teamleader-gebruiker, per verkoper via de
// reseller-gebruiker (zie /api/reference/reseller-fees). Voor een enkele partner
// is contractueel iets anders afgesproken. Die afspraken staan hier en niet in de
// gebruikersadministratie, om twee redenen:
//   - ze gelden ook als er (nog) geen teamleader-account voor dat team bestaat —
//     anders zou zo'n team stilzwijgend op de default van 75% terugvallen;
//   - ze mogen niet veranderen doordat iemand een gebruikersprofiel aanpast.
//
// De sleutel is de COMBINATIE (energielabel, verkoopteam). Bewust niet de
// teamnaam alleen: naast "HOA Team (P2Y)" onder Power2You bestaat er ook een
// "HOA Team" onder HOA Energy, en dat team volgt gewoon de standaardregel.
export const RESELLER_FEE_UITZONDERINGEN = [
  // Afgesproken met de partner: 100% i.p.v. de gebruikelijke 75%.
  { energyLabel: 'Power2You', salesTeam: 'HOA Team (P2Y)', pct: 100 },
];

const norm = (v) => String(v == null ? '' : v).trim().toLowerCase();

// Het uitzonderingspercentage voor deze combinatie, of null als er geen afspraak is.
export function resellerFeeUitzondering(energyLabel, salesTeam, lijst = RESELLER_FEE_UITZONDERINGEN) {
  if (!energyLabel || !salesTeam) return null;
  const hit = lijst.find(
    // bronLabel: een prospect ziet zijn eigen labelnaam, maar rekent als het bronlabel.
    (u) => norm(u.energyLabel) === norm(bronLabel(energyLabel)) && norm(u.salesTeam) === norm(salesTeam)
  );
  return hit ? hit.pct : null;
}

// Hoort deze verkoper binnen dit energielabel bij een uitzonderingsteam?
// Nodig omdat admin ook op verkoper alleen kan filteren, zonder het team te kiezen;
// de afspraak geldt dan even goed. `structure` is de sales-structuur
// (`sellers_by_label_team[label][team] = [verkopers]`).
export function resellerFeeUitzonderingViaVerkoper(structure, energyLabel, seller, lijst = RESELLER_FEE_UITZONDERINGEN) {
  if (!energyLabel || !seller) return null;
  const teams = ((structure || {}).sellers_by_label_team || {})[energyLabel] || {};
  for (const [team, sellers] of Object.entries(teams)) {
    if ((sellers || []).some((s) => norm(s) === norm(seller))) {
      const pct = resellerFeeUitzondering(energyLabel, team, lijst);
      if (pct != null) return pct;
    }
  }
  return null;
}
